module.exports = __webpack_public_path__ + "images/notifications-onboarding/context_Illos.5c4725bd2598b55805cb.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/notifications-onboarding/context_Illos.svg
// module id = XgAL
// module chunks = 13